import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../components/BillingMDC';

class CreateGRNTableBody extends Component {
  render() {
    const { data, index } = this.props;
    return (
      <tr>
        <td>{index + 1}</td>
        <td>{data.skuTitle}</td>
        <td>{data.batchTitle}</td>
        <td className='right-align'>{data.quantity}</td>
        <td className='right-align'>{data.rate}</td>
        <td className='right-align'>{data.amount}</td>
        <td className='right-align'>{data.discount}</td>
        <td className='right-align'>{data.net_amount}</td>
        <td className='right-align'>
          <Icon name='edit' onClick={() => this.props.handleEditIconClick(data, index)} />
          <Icon name='delete' onClick={() => this.props.handleDeleteIconClick(index)} />
        </td>
      </tr>
    );
  }
}

CreateGRNTableBody.defaultProps = { enableUpdate: true, };

CreateGRNTableBody.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleDeleteIconClick: PropTypes.func.isRequired,
  handleEditIconClick: PropTypes.func.isRequired,
  enableUpdate: PropTypes.bool,
};

const createGRNConfig = {
  headerDetails: [
    { id: 1, label: 'test', title: 'SN', className: null, sortable: false },
    { id: 2, label: 'sku', title: 'SKU', className: null, sortable: false },
    { id: 2, label: 'batchTitle', title: 'Batch', className: null, sortable: false },
    { id: 3, label: 'quantity', title: 'Quantity (pcs)', className: 'right-align', sortable: false },
    { id: 4, label: 'rate', title: 'Rate', className: 'right-align', sortable: false },
    { id: 5, label: 'amount', title: 'Amount', className: 'right-align', sortable: false },
    { id: 6, label: 'discount', title: 'Discount', className: 'right-align', sortable: false },
    { id: 7, label: 'net_amount', title: 'Net Amount', className: 'right-align', sortable: false },
    { id: 8, label: 'test', title: '', className: 'right-align', sortable: false },
  ],
};

export { createGRNConfig, CreateGRNTableBody };
